import { API } from "aws-amplify";

import { logError } from "../../../../utils/appUtils";

export const sendEmails = async (reloadYardAccounts, generateEmailContent) => {
  try {
    if (
      typeof reloadYardAccounts === "object" &&
      !Array.isArray(reloadYardAccounts)
    ) {
      reloadYardAccounts = [reloadYardAccounts];
    }

    const promises = [];
    for (const record of reloadYardAccounts) {
      const emailContent = generateEmailContent(
        record.email,
        `${record.firstName} ${record.lastName}`,
        record.accountName || record.reloadYardName
      );

      const promise = API.post("transREST", "/sendEmail", {
        body: {
          to: record.email,
          bcc: ["support@transloads.co"],
          subject: "Carrier User Deletion Notice",
          template: "emailTemplate.html",
          htmlContent: emailContent,
        },
      });
      promises.push(promise);
    }

    // Wait for all email sending promises to resolve
    await Promise.all(promises);
  } catch (error) {
    logError("managerApp:carriers:carrierUtils", error, false);
  }
};
